import { ValidateRow } from "../../services/itemImportStaging.ts";

export const MIGRATION_SESSION_KEY = "eskaiy_data_migration_session";

export type PreviewSubView = "summary" | "preview";

export interface MigrationFieldMapping {
  brandName: string;
  mainCategory: string;
  category: string;
  subCategory: string;
  genericName: string;
  itemName: string;
  uom: string;
  packagingType: string;
  modelName: string;
  unitPerPackage: string;
  description: string;
  isSelling: string;
  isInventory: string;
}

export interface MigrationVariantSlot {
  id: number;
  excelHeader: string;
}

export interface MigrationExcelRow {
  _rowNumber: number;
  [key: string]: string | number;
}

export interface MigrationValidationError {
  field: string;
  message: string;
}

export interface MigrationValidationErrorRow {
  row: number;
  item: string;
  errors: MigrationValidationError[];
}

export interface MigrationValidationResults {
  totalRows: number;
  validRows: number;
  invalidRows: number;
  errors: MigrationValidationErrorRow[];
}

export interface MigrationSessionData {
  currentStep: number;
  /** Step 3 internal sub-view: validation summary vs data preview */
  previewSubView: PreviewSubView;
  excelData: MigrationExcelRow[];
  excelHeaders: string[];
  fieldMapping: MigrationFieldMapping;
  variantFieldMappings: MigrationVariantSlot[];
  dbValidationRows: ValidateRow[];
  validationResults: MigrationValidationResults;
  duplicateRowCount: number;
  selectedRows: number[];
  displayData: Record<string, unknown>[];
  allPreviewRows?: Array<Record<string, unknown> & { _recordStatus?: string }>;
  startRow: number;
  startCol: number;
  hasHeaders: boolean;
  fileType: string;
  uploadedFileName: string;
  startRowInput: string;
  startColLetter: string;
}

export const saveMigrationSession = (data: MigrationSessionData): void => {
  try {
    sessionStorage.setItem(MIGRATION_SESSION_KEY, JSON.stringify(data));
  } catch {
    // ignore quota errors
  }
};

export const loadMigrationSession = (): MigrationSessionData | null => {
  try {
    const raw = sessionStorage.getItem(MIGRATION_SESSION_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as MigrationSessionData;
  } catch {
    return null;
  }
};

export const clearMigrationSession = (): void => {
  try {
    sessionStorage.removeItem(MIGRATION_SESSION_KEY);
  } catch {
    // ignore
  }
};

export const hasMigrationSession = (): boolean => {
  try {
    return sessionStorage.getItem(MIGRATION_SESSION_KEY) != null;
  } catch {
    return false;
  }
};
